<app-whatsapp-button></app-whatsapp-button>
<!-- LOGIN -->
<div *ngIf="cookiesEnabled" class="container">
    <ng-template #modalInfo let-modal>
      <div class="modal-header">
        <h1 class="modal-title" id="modalInfoLabel">Política de Privacidade</h1>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body"><p [innerHTML]="privacy"></p></div>
    </ng-template>
    <div class="row justify-content-center">
        <div class="col-11 col-lg-5">
            <div class="justify-content-center">
                <h1 [innerHTML]="pageTitle"></h1>
            </div>
            <p>Bem-vindo! Teste</p>
            <p [innerHTML]="loginText"></p>

            <p [innerHTML]="loginObs"></p>
            <p *ngIf="features.loginEmpresa" class="text-center"><a class="login-link" routerLink="/login/empresa">Se for uma empresa, clique aqui.</a></p>
            <div *ngIf="popUp && cookieShow()" style="display: block; position: fixed; z-index: 1; bottom: 0; left: 0; width: 100%; padding: 1rem 2rem 1rem 0; background: #fff; color: #000; border-top: 1px solid #e1e0e3;">
              <div style="width: 90%; max-width: 1140px; margin: 0 auto;">
                <div style="width: 100%; display: flex; justify-content: space-between; grid-column-gap: 2rem;">
                  <div style="display: flex; flex-direction: column; width: 75%;">
                    <p style="margin: auto;"><span [innerHTML]="popUp"></span><span *ngIf="privacy"><a href="javascript:;" (click)="openModal(modalInfo)" oncontextmenu="return false;">Política de Privacidade</a>.<br><span [innerHTML]="privacy" *ngIf="privacyShow"></span></span></p>
                  </div>
                  <div style="display: flex; flex-direction: column; width: 25%;">
                    <p class="btn btn-primary btn-block" (click)="cookieDismiss()">OK</p>
                  </div>
                </div>
              </div>
            </div>
        </div> <!-- /col -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
        <div class="col-12 col-lg-6">

            <div class="form-panel form-panel-lg" [ng2-loading]="showSpinner">
                <p *ngIf="features.signUp" class="text-center">
                  <a>Ainda não tem uma conta?</a><br>
                  <span class="btn btn-primary btn-block mb-3" routerLink="/cadastro">Cadastre-se</span>
                </p>
                <hr *ngIf="features.signUp">
                <h2>Entrar</h2>
                <form name="form" (ngSubmit)="f.form.valid && efetuarLogin()" #f="ngForm">
                    <div class="form-group">
                      <label for="email">Login <span style="color: #4b4b4b;">(<span *ngIf="features.login.includes( 'docs' )">RG, CPF</span><span *ngIf="features.login.includes( 'docs' ) && features.login.includes( 'email' )"> ou </span><span *ngIf="features.login.includes( 'email' )">Email</span>)</span></label>
                        <input type="text" class="form-control" id="email" name="email" placeholder="" [(ngModel)]="model.login" required>
                    </div>

                    <div class="form-group" [ngClass]="{ 'invalid': (senha.invalid && senha.touched) || (senha.invalid && f.submitted) }">
                        <label>Senha</label>
                        <input type="password" name="senha" class="form-control" [(ngModel)]="model.senha" #senha="ngModel" [ngClass]="{ 'is-invalid': senha.touched && senha.invalid }" required>
                    </div>

                    <div class="form-group center">
                        <re-captcha (resolved)="resolved($event)" [siteKey]="reCaptchaKey"></re-captcha>
                    </div>

                    <p class="caption" style="margin-top: 10px;"><a routerLink="/esqueci">Esqueci minha senha</a></p>
                    <button type="submit" class="btn btn-primary btn-block mb-3">Entrar</button>
                </form>
            </div> <!-- /form-panel -->

            <!-- <div class="form-panel form-panel-lg">
                <p class="caption">Entre também com suas redes sociais:</p>
                <div class="row justify-content-center">
                    <div class="col-12 mb-3">
                        <a href="#" class="btn btn-default btn-block btn-login" id="btn-google">
                            <img src="assets/google.svg" alt="Botão Entrar com Google"> Entrar com Google
                        </a>
                    </div>

                    <div class="col-12">
                        <a (click)="signInWithFB()" class="btn btn-default btn-block btn-login" id="btn-facebook">
                            <img src="assets/facebook.svg" alt="Botão Entrar com Facebook"> Entrar com Facebook
                        </a>
                    </div>
                </div>
            </div> /form-panel -->

        </div> <!-- /form -->
    </div> <!-- /row -->
</div> <!-- /container -->
<!-- LOGIN -->
<div style="margin-bottom: 180px; margin-top: 80px;"  *ngIf="!cookiesEnabled" class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h2>
        <svg width="20px" heigth="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"/></svg>
        ALERTA
      </h2>
    </div>
    <div class="modal-body">
      <div>
        Por favor, ative os cookies do navegador e atualize a página.
      </div>
    </div>
  </div>
</div>
